





































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { mask } from 'vue-the-mask';
import {
  PartnersApi, Partner,
} from '@compassdigital/foodworks.ts.sdk';
import { cloneDeep } from 'lodash';
import RestaurantInformation from '@/components/Form/Partner/RestaurantInformation/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import EditConfirmation from '@/components/Form/EditConfirmation/index.vue';
import CustomDropdown from '@/components/Form/CustomDropdown/index.vue';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import Format from '@/util/Format';

@Component({
  components: {
    RestaurantInformation,
    Textfield,
    CustomDropdown,
    EditConfirmation,
  },
  directives: { mask },
})
export default class RestaurantInformationEdit extends Vue {
  @Prop() readonly restaurantInfo?: Partner;

  @Watch('restaurantInfo', { immediate: true })
  onContactInfoChanged(val: any) {
    this.restaurantInfoLocal = cloneDeep(val);
  }

  public edit: boolean = false;

  public loading: boolean = false;

  public restaurantInfoLocal: any = {};

  public shouldStick: boolean = true;

  private marketInfo: any = {
    partnerType: 'restaurant',
  };

  get businessNumber() {
    if (this.restaurantInfoLocal) {
      const { phone } = this.restaurantInfoLocal.businessNumber;
      return Format.maskPhoneNumber(phone);
    }
    return '';
  }

  get addressLine() {
    let line = '';
    if (this.restaurantInfoLocal) {
      const {
        address: {
          address, city, state, country, zip,
        },
      } = this.restaurantInfoLocal;
      line = `${address} </br> ${city}, ${state} ${zip}</br> ${country}`;
    }
    return line;
  }

  public onEdit() {
    if (this.restaurantInfo) {
      this.restaurantInfoLocal = cloneDeep(this.restaurantInfo);
    }
    this.edit = false;
  }

  public async onSave() {
    if (
      (this.$refs.form as any).validate()
      && this.restaurantInfoLocal !== null
    ) {
      this.loading = true;
      try {
        const restInfo: any = { ...this.restaurantInfoLocal };
        const { phone } = restInfo.businessNumber;
        if (phone) {
          restInfo.businessNumber.phone = Format.CheckMaskNumber(phone);
        } else {
          restInfo.businessNumber.phone = Number(
            restInfo.businessNumber.phone,
          );
        }
        const cuisines: any = [];
        cuisines.push(restInfo.cuisineTypes);
        restInfo.cuisineTypes = cuisines;
        const api = new PartnersApi(AppModule.apiConfig);
        const restaurant = await api.patchPartnerById(restInfo.id, restInfo);
        const updateRestaurant = await api.getPartnerById(restInfo.id);
        this.restaurantInfoLocal = updateRestaurant.data;
        UserModule.SET_CURRENT_PARTNER({ ...UserModule.currentPartner, ...restInfo });
        this.edit = false;
        this.$emit('input', restInfo);
      } catch (err) {
        console.log('err', err.response.data);
      }
      this.loading = false;
    }
  }
}
